export default __webpack_public_path__ + "static/media/saderat-logo.4ebc867d.webp";